import * as e from "react";
import { forwardRef as t } from "react";
const C = t(function(o, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM13.1666 8.49997C13.1666 9.1443 12.6443 9.66664 12 9.66664C11.3556 9.66664 10.8333 9.1443 10.8333 8.49997C10.8333 7.85564 11.3556 7.3333 12 7.3333C12.6443 7.3333 13.1666 7.85564 13.1666 8.49997ZM12 11C12.5523 11 13 11.4477 13 12V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V12C11 11.4477 11.4477 11 12 11Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  C as Info
};
